import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const LegacyPWABlocked = () => import(/* webpackChunkName: "4-feat-legacy-pwa-blocked" */ './LegacyPWABlocked');

const LoadableLegacyPWABlocked: ComponentType = lazyLoadOnRender({ loader: LegacyPWABlocked });
export default LoadableLegacyPWABlocked;
